module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.198f2e08.svg";